import React, { useState, useEffect } from 'react';
import Api from "../../services/Api";
import CoachMatching from "../../components/CoachMatching/CoachMatching";
import {ClientProfile, CoachInterface} from "../../interfaces/common";


const MyCoachPage: React.FC = () => {
  const api = Api.getInstance();
  const [coachData, setCoachData] = useState<CoachInterface | null>(null);
  const [clientProfile, setClientProfile] = useState<ClientProfile>();
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    getData();
  }, [])

  const getData = () => {
    api.get('client/my_coach').then(response => {
      setCoachData(response.json.coach)
      setClientProfile(response.json.clientProfile)
      setLoaded(true)
    })
  }

  if (!loaded || !coachData || !clientProfile) {
    return (
      <div className="mt-4">Loading...</div>
    )
  }

  return (
    <CoachMatching coach={coachData} clientProfile={clientProfile}/>
  )

};

export default MyCoachPage;
